import _sfc_main from "./ProjectIcon.vue2.js";
import "./ProjectIcon.vue3.js";
import _export_sfc from "../_virtual/_plugin-vue_export-helper.js";
const ProjectIcon = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-b20ed538"]]);
export {
  ProjectIcon as default
};
//# sourceMappingURL=ProjectIcon.vue.js.map
